// src/services/firebaseConfig.js


import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { 
  getMessaging, 
  getToken, 
  onMessage, 
  deleteToken, 
  isSupported   // ✅ Add this line
} from 'firebase/messaging';





// export const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID
// };

export const firebaseConfig = {
  apiKey: "AIzaSyB7oMoh1ZAVf99yrykB_Vj45KE84QsQvnw",
  authDomain: "zyppro-rms-prod.firebaseapp.com",
  databaseURL: "https://zyppro-rms-prod-default-rtdb.firebaseio.com/",
  projectId: "zyppro-rms-prod",
  storageBucket: "zyppro-rms-prod.firebasestorage.app",
  messagingSenderId: "364715307295",
  appId: "1:364715307295:web:5bb99532fcdea3a32f002a",
  measurementId: "G-J46YFCP3JV"
};


// Initialize Firebase
let app;
let db;
let storage;
let messaging = null;
let auth;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  storage = getStorage(app);
  auth = getAuth(app);


  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    isSupported()
      .then(supported => {
        if (supported) {
          messaging = getMessaging(app);
          //console.log('✅ Firebase Messaging initialized');
        } else {
          console.warn('⚠️ Firebase Messaging not supported in this browser');
        }
      })
      .catch(err => {
        console.warn('⚠️ Error checking FCM support:', err);
      });
  }



  enableIndexedDbPersistence(db).catch(err => {
    if (err.code === 'failed-precondition') {
      console.warn('⚠️ Multiple tabs open, persistence enabled in only one tab.');
    } else if (err.code === 'unimplemented') {
      console.warn('⚠️ Browser does not support persistence.');
    }
  });

  //console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
}

export { app, db, storage, auth,messaging, getToken, onMessage, deleteToken };
export default app;